import { render, staticRenderFns } from "./matrixinput.vue?vue&type=template&id=554894f9&scoped=true&"
import script from "./matrixinput.vue?vue&type=script&lang=js&"
export * from "./matrixinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554894f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554894f9')) {
      api.createRecord('554894f9', component.options)
    } else {
      api.reload('554894f9', component.options)
    }
    module.hot.accept("./matrixinput.vue?vue&type=template&id=554894f9&scoped=true&", function () {
      api.rerender('554894f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/matrixinput.vue"
export default component.exports